import React, { Component } from 'react'
import { Card, Col, Row } from "reactstrap";
// import Table from "./Table";
import PieChart from "./charts/PieChart";
import BarChart from "./charts/BarChart";
import StackedBar from "./charts/StackedBar";
import BarLine from "./charts/BarLine";
import MiniKPITrendline from "./charts/MiniKPITrendline";
// import MultiType from "./charts/MultiType";
import MultiType from "./charts/MultiType";
import Line from "./charts/Line";
import FloatingBar from "./charts/FloatingBar";
import MiniKpi from "./charts/MiniKpi";
import Area from "./charts/Area";
import PivotTable from "./charts/PivotTable";
import RadialChart from "./charts/RadialBar";
import MultiAxix from "./charts/MultiAxis";
import GroupBar from "./charts/GroupBar";
import Gauge from "./charts/Gauge";
function Chart(props){
      
  return(
    <>
      <div className='cockpitChart'>      
           {(() => {
                switch(props.ChartTypes[props.prams.chartType]) {
                    case "Pie":
                        return (
                          <PieChart prams={props} />
                        )
                    case "Bar":
                        return (
                           <BarChart prams={props}/>
                         )
                    case "Bar with Line":
                        return (
                             <BarLine prams={props}/>
                        )
                                                      
                    case "Grouped Bar":
                        return (
                              <GroupBar prams={props}/>
                            )       
                    case "StackedBar":
                        return (
                              <StackedBar prams={props}/>
                            )                            
                    case "Donut":
                         return (
                           <PieChart prams={props}/>
                     )    
                     case "MultiType":
                      return (
                        <BarChart prams={props}/>
                     )
                     case "Stacked Bar":
                      return (
                        <StackedBar prams={props}/>
                     )
                     case "Area":
                      return (
                        <Area prams={props}/>
                     )     
                     case "Area with Line":
                      return (
                        <Area prams={props}/>
                     )      
                     case "Line":
                         return (
                           <Line prams={props}/>
                     ) 
                     case "Bar with Line":
                         return (
                           <BarChart prams={props}/>
                     ) 
                     case "Multi Axis":
                         return (
                           <MultiAxix prams={props}/>
                     ) 
                     case "Gauge":
                         return (
                           <Gauge prams={props}/>
                     )   
                     case "Mini KPI":
                         return (
                           <MiniKpi prams={props}/>
                     )   
                     case "Radial Bar":
                         return (
                           <RadialChart prams={props}/>
                     )    
                     case "Mini KPI with Trendline":
                         return (
                           <MiniKPITrendline prams={props}/>
                     )  
                     case "Data Pivot":
                         return (
                           <PivotTable prams={props}/>
                     )  
                     //FloatingBar
                      default:    
                    return (
                        <>
                          <div className='Polar'>
                            <div className='row'>
                              <div className='col-lg-12'>
                                <div className='componentNameC'>Component Not Found</div>
                              </div>
                            </div>
                            <div className="p-4 Polar1" style={{      
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexDirection: 'column',
                              height: '100vh', // Optionally set a height to center vertically in the viewport
                              color: '#85929E'}}>
                               {props.ChartTypes[props.prams.chartType]} Chart Not Found                                
                            </div>
                          </div>                        
                        </>
                  )
                }
            })()}
      </div>
    </>
  )
}
export default Chart